import React, { Component } from 'react'

class StatBox extends Component {
  constructor (props) {
    super(props)
    this.state = {
      xs: 'col-xs-' + (this.props.xs || this.props.cols),
      sm: 'col-sm-' + (this.props.sm || this.props.cols),
      md: 'col-md-' + this.props.cols,
      lg: 'col-lg-' + (this.props.lg || this.props.cols)
    }
  }
  render () {
    return (
      <div className='statbox-wrapper'>
        <div className={[this.state.xs, this.state.sm, this.state.md, this.state.lg].join(' ')}>
          <div className={this.props.percentage > 24 ? 'statbox-inner statbox-success' : 'statbox-inner statbox-danger'}>
            <div className='statbox-arrow'>
              <i className={this.props.percentage > 24 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'} />
            </div>
            <div className='statbox-content'>
              <h3 className='statbox-name'>{this.props.title}</h3>
              <div className={this.props.percentage > 24 ? 'statbox-progress statbox-progress-success' : 'statbox-progress statbox-progress-danger'}>
                <div className='statbox-progressbar' style={{ 'width': this.props.percentage + '%' }} />
              </div>
              <h3 className='statbox-text'>{this.props.percentage > 24 ? this.props.percentage + '% increase in 30 days' : this.props.percentage + '% decrease in 30 days'}</h3>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default StatBox



// WEBPACK FOOTER //
// ./src/components/basic/displays/StatBox.js